// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"300":"c05f59a8e1c60655","521":"f64c43297424d0f5"}[chunkId] + ".js";
};